<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Promo/Detail</h1>
      </div>
      <div class="flex">
        <div @click="showModalDestroy" class="mr-5 cursor-pointer">
          <fas icon="trash-alt" class="text-red-600 text-2xl" />
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Carousel (1200 px X 500 px)</div>
            <div @click="showModalCarouselFile" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              class="w-full lg:w-1/2 mr-3 h-44 lg:h-80"
              :src="dataPromo.promotion_carousel"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Products (1020 px X 1020 px)</div>
            <div @click="showModalProductFile" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              :key="dataPromo.promotion_images"
              class="w-40 h-40 mr-3"
              :src="dataPromo.promotion_images"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Promo Info</div>
            <div @click="showModalEditPromoInfo" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="font-semibold">Tenant</div>
          <div
            v-if="
              dataPromo?.tenant?.tenant_name !== '' ||
                dataPromo?.tenant?.tenant_name !== undefined
            "
            class="ml-5"
          >
            <router-link
              :to="'/tenant/' + tenant_id"
              class="bg-app-default border-2 p-2 text-white font-bold rounded-md"
            >
              {{ dataPromo?.tenant?.tenant_name }}
            </router-link>
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Name</div>
          <div v-if="dataPromo.promotion_name !== ''" class="ml-5">
            {{ dataPromo.promotion_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Description</div>
          <!-- <div v-if="dataPromo.promotion_description !== ''" class="ml-5">
            {{ dataPromo.promotion_description }}
          </div>
          <div v-else class="ml-5">-</div> -->
          <div class="ml-5" v-html="dataPromo.promotion_description"></div>
          <div class="font-semibold">Category</div>
          <div v-if="dataPromo?.category?.promotion_category_name !== ''" class="ml-5">
            {{ dataPromo?.category?.promotion_category_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Status</div>
          <div v-if="dataPromo.is_active" class="ml-5">Active</div>
          <div v-else class="ml-5">Non Active</div>
          <div class="font-semibold">Promo Start</div>
          <div v-if="dataPromo.promotion_start !== null" class="ml-5">
            {{ promotion_start }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Promo End</div>
          <div v-if="dataPromo.promotion_end !== null" class="ml-5">
            {{ promotion_end }}
          </div>
          <div v-else class="ml-5">-</div>
        </div>
      </div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalDestroy"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Warning !</div>
          <div class="p-6 flex-grow">
            Continue To Delete This Promo
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="deletePromo"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Update -->
    <div
      v-if="modalInfoPromo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEditPromoInfo"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Edit Content</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Promo Status</label
                >
                <div class="flex flex-row items-center h-9 mb-5">
                  <div
                    class="relative cursor-pointer"
                    @click="update.is_active = !update.is_active"
                  >
                    <div
                      class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                      :class="{ 'bg-app-default': update.is_active }"
                    ></div>
                    <div
                      class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                      :class="{ 'translate-x-6': update.is_active }"
                    ></div>
                  </div>
                </div>
              </div>

              <Select
                :selectItem="selectItem"
                :data="dropDown.dataSelect"
                :open="dropDown.isOpen"
                :selected="dropDown.selected"
                :openSelect="openSelect"
                :search="onSearch"
                :inputSearch="dropDown.inputSearch"
                :id="update.tenant_id"
                :isError="errors.tenant_id"
                :errorMessage="errors.tenant_id_msg"
                :title="dropDown.title"
              />

              <Select
                :selectItem="categorySelectItem"
                :data="categoryDropDown.dataSelect"
                :open="categoryDropDown.isOpen"
                :selected="categoryDropDown.selected"
                :openSelect="categoryOpenSelect"
                :id="update.category_promotion_id"
                :isError="errors.category_promotion_id"
                :errorMessage="errors.category_promotion_id_msg"
                :title="categoryDropDown.title"
              />

              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Promo Name</label
                >
                <input
                  v-model="update.promotion_name"
                  @keyup="promotionNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.promotion_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.promotion_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Promo Description</label
                >
                <!-- <textarea
                  v-model="update.promotion_description"
                  @keyup="promotionDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.promotion_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.promotion_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="update.promotion_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="promotionDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.promotion_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.promotion_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.promotion_description_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Star Promo</label
                >
                <v-date-picker
                  timezone="Asia/Jakarta"
                  v-model="update.promotion_start"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >End Promo</label
                >
                <v-date-picker
                  timezone="Asia/Jakarta"
                  v-model="update.promotion_end"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEditPromoInfo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updatePromoInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEditPromoInfo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Carousel -->
    <div
      v-if="modalCarousel"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Carousel (1200 px X 500 px)
            </div>
            <div class="">
              <button
                @click.self="showModalCarouselFile"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.carousel_image ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewFileCarousel"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewFileCarousel"
                  id="carousel_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="avatar.previewCarousel"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeCarouselFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="avatar.previewCarousel"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewCarousel === null"
                    v-cloak
                    @click="chooseCarouselFile()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.carousel_image_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalCarouselFile"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!avatar.previewCarousel"
                @click="updateCarousel"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  !avatar.previewCarousel ? 'bg-gray-500' : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalCarouselFile"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal product -->
    <div
      v-if="productModal"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 450px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Product (1020 px X 1020 px)
            </div>
            <div class="">
              <button
                @click.self="showModalProductFile"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div
              class="border-dotted border-2 p-2 rounded-lg"
              :class="[
                errors.product_images ? 'border-red-400' : 'border-black',
              ]"
              @drop="previewFileProduct"
            >
              <input
                type="file"
                accept="image/*"
                @change="previewFileProduct"
                id="product_file"
                class="opacity-0 hidden"
              />
              <div class="flex flex-row flex-wrap">
                <div
                  v-if="avatar.previewProducts.length"
                  class="mr-1 relative rounded-lg"
                >
                  <button
                    class="absolute right-2 top-2"
                    type="button"
                    @click="removeProductFile"
                  >
                    <fas icon="trash-alt" class="text-red-600 text-3xl" />
                  </button>
                  <img
                    :src="avatar.previewProducts[0]"
                    class="w-96 h-80 rounded-lg"
                  />
                </div>
                <div
                  v-if="avatar.previewProducts.length === 0"
                  v-cloak
                  @click="chooseFileProduct()"
                  class="w-96 h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                >
                  <fas icon="image" class="text-gray-600 text-3xl" />
                </div>
              </div>
            </div>
            <div class="text-sm text-red-600 mb-5">
              {{ errors.product_images_msg }}
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalProductFile"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="avatar.previewProducts.length === 0"
                @click="updateImageProductPromo"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  avatar.previewProducts.length === 0
                    ? 'bg-gray-500'
                    : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalProductFile"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Warning /><SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import BackButton from "../../components/BackButton.vue";
import Select from "../../components/Select.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "ContentDetail",
  components: {
    Select,
    Warning,
    BackButton,
    SuccessNotif,
    CKEditor,
  },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      dataPromo: {},
      // promoCategoryList: [],
      tenantList: [],
      modalDestroy: false,
      modalInfoPromo: false,
      modalCarousel: false,
      productModal: false,
      tenant_id: null,
      promotion_start: "",
      promotion_end: "",
      dropDown: {
        isOpen: false,
        dataSelect: [],
        inputSearch: true,
        title: "Nama Tenant",
        selected: "pilih sesuatu",
      },
      categoryDropDown: {
        isOpen: false,
        dataSelect: [],
        title: "Category Promo",
        selected: "pilih sesuatu",
      },
      errors: {
        product_images: false,
        carousel_image: false,
        tenant_id: false,
        category_promotion_id: false,
        promotion_name: false,
        promotion_description: false,
        promotion_start: false,
        promotion_end: false,
        is_active: false,
        product_images_msg: "",
        carousel_image_msg: "",
        tenant_id_msg: "",
        category_promotion_id_msg: "",
        promotion_name_msg: "",
        promotion_description_msg: "",
        promotion_start_msg: "",
        promotion_end_msg: "",
        is_active_msg: "",
      },
      update: {
        tenant_id: null,
        category_promotion_id: null,
        promotion_name: "",
        promotion_description: "",
        promotion_start: new Date(),
        promotion_end: new Date(),
        is_active: true,
      },
      avatar: {
        previewCarousel: null,
        fileCarousel: null,
        previewProducts: [],
        fileProducts: [],
      },
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    promotionNameChange: function(e) {
      this.update.promotion_name = e.target.value;
      this.errors.promotion_name = false;
      this.errors.promotion_name_msg = "";
    },
    promotionDescriptionChange: function() {
      // this.update.promotion_description = e.target.value;
      this.errors.promotion_description = false;
      this.errors.promotion_description_msg = "";
    },
    categoryOpenSelect: function() {
      this.categoryDropDown.isOpen = !this.categoryDropDown.isOpen;
    },
    categorySelectItem: function(val) {
      this.categoryDropDown.isOpen = false;
      this.update.category_promotion_id = val.id;
      this.errors.category_promotion_id_msg = "";
      this.errors.category_promotion_id = false;
      this.categoryDropDown.selected = val.name;
    },
    openSelect: function() {
      this.dropDown.isOpen = !this.dropDown.isOpen;
    },
    selectItem: function(val) {
      this.dropDown.isOpen = false;
      // this.create.tenant_id = val.id
      this.update.tenant_id = val.id;
      this.dropDown.selected = val.name;
    },
    onSearch: function(val) {
      this.findTenant(val);
    },
    chooseFileProduct: function() {
      document.getElementById("product_file").click();
    },
    chooseCarouselFile: function() {
      document.getElementById("carousel_file").click();
    },
    removeProductFile() {
      this.avatar.previewProducts = [];
      this.avatar.fileProducts = [];
    },
    removeCarouselFile: function() {
      this.avatar.previewCarousel = null;
      this.avatar.fileCarousel = null;
    },
    previewFileProduct: function(event) {
      let input = event.target;
      let count = input.files.length;
      let index = 0;
      if (input.files) {
        while (count--) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.avatar.previewProducts.push(e.target.result);
          };
          this.avatar.fileProducts.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      }
      this.errors.product_images = false;
      this.errors.product_images_msg = "";
    },
    previewFileCarousel: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatar.previewCarousel = e.target.result;
        };
        this.avatar.fileCarousel = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.carousel_image = false;
      this.errors.carousel_image_msg = "";
    },
    showModalDestroy: function() {
      this.modalDestroy = !this.modalDestroy;
    },
    showModalCarouselFile: function() {
      this.avatar = {
        previewCarousel: null,
        fileCarousel: null,
        previewProducts: [],
        fileProducts: [],
      };
      this.modalCarousel = !this.modalCarousel;
    },
    showModalProductFile: function() {
      this.avatar = {
        previewCarousel: null,
        fileCarousel: null,
        previewProducts: [],
        fileProducts: [],
      };
      this.productModal = !this.productModal;
    },
    showModalEditPromoInfo: function() {
      this.update.category_promotion_id = this.dataPromo.category_promotion_id;
      this.update.promotion_name = this.dataPromo.promotion_name;
      this.update.promotion_description = this.dataPromo.promotion_description;
      this.update.promotion_start = this.dataPromo.promotion_start;
      this.update.promotion_end = this.dataPromo.promotion_end;
      this.update.tenant_id = this.dataPromo.tenant_id;
      this.update.is_active = this.dataPromo.is_active;
      this.dropDown.selected = this.dataPromo.tenant.tenant_name;
      this.categoryDropDown.selected = this.dataPromo?.category?.promotion_category_name;
      this.modalInfoPromo = !this.modalInfoPromo;
    },
    deletePromo: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.dataPromo.id,
          }),
        });
        let respon = await res.json();
        if (respon.status === 400) {
          this._error(respon.message);
          this.modalDestroy = false;
          this.deleteButton = "Delete";
          return;
        } else if (respon.status !== 200) {
          this._error("internal server error");
          this.modalDestroy = false;
          this.deleteButton = "Delete";
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.$router.push(`/promo`);
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    updateCarousel: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("carousel_image", this.avatar.fileCarousel);
      formdata.append("id", this.dataPromo.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/update-image-carousel`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "carousel_image") {
                this.errors.carousel_image = true;
                this.errors.carousel_image_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalCarousel = false;
        this.saveButton = "Save";
        this.detailPromo();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalCarousel = false;
        this._error("internal server error");
      }
    },
    updateImageProductPromo: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("id", this.dataPromo.id);
      this.avatar.fileProducts.map((itm) => {
        formdata.append("product_images", itm);
      });
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/update-image-product`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "product_images") {
                this.errors.product_images = true;
                this.errors.product_images_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.productModal = false;
        this.saveButton = "Save";
        this.detailPromo();
        this._success("Data updated.");
      } catch (err) {
        this.productModal = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updatePromoInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.dataPromo.id,
            tenant_id: this.update.tenant_id,
            category_promotion_id: this.update.category_promotion_id,
            promotion_name: this.update.promotion_name,
            promotion_description: this.update.promotion_description,
            promotion_start: this.update.promotion_start,
            promotion_end: this.update.promotion_end,
            is_active: this.update.is_active,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "tenant_id") {
                this.errors.tenant_id = true;
                this.errors.tenant_id_msg = item.message;
              }
              if (item.key === "category_promotion_id") {
                this.errors.category_promotion_id = true;
                this.errors.category_promotion_id_msg = item.message;
              }
              if (item.key === "promotion_name") {
                this.errors.promotion_name = true;
                this.errors.promotion_name_msg = item.message;
              }
              if (item.key === "promotion_description") {
                this.errors.promotion_description = true;
                this.errors.promotion_description_msg = item.message;
              }
              if (item.key === "promotion_start") {
                this.errors.promotion_start = true;
                this.errors.promotion_start_msg = item.message;
              }
              if (item.key === "promotion_end") {
                this.errors.promotion_end = true;
                this.errors.promotion_end_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalInfoPromo = false;
        this.detailPromo();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalInfoPromo = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    detailPromo: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.dataPromo = respon.data;
        this.tenant_id = respon.data.tenant_id;
        let stE = new Date(respon.data.promotion_start);
        let enE = new Date(respon.data.promotion_end);
        this.promotion_start = `${stE.getDate()}-${stE.getMonth() +
          1}-${stE.getFullYear()} ${stE.getHours()}:${stE.getMinutes()}`;
        this.promotion_end = `${enE.getDate()}-${enE.getMonth() +
          1}-${enE.getFullYear()} ${enE.getHours()}:${enE.getMinutes()}`;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findCategoryPromo: async function() {
      try {
        let res = await fetch(`${API}v1/promotion-categories`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.categoryDropDown.dataSelect = respon.data.map((itm) => {
          return {
            id: itm.id,
            name: itm.promotion_category_name,
          };
        });
      } catch (err) {
        this._error("internal server error");
      }
    },
    findTenant: async function(keword) {
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants?search=${keword}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.dropDown.dataSelect = respon.data.tenants;
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailPromo();
    this.findCategoryPromo();
    this.findTenant("");
  },
};
</script>
